function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { ReactComponent as AduitSvg } from "../../assets/svg/aduit.svg";
import { ReactComponent as ExportSvg } from "../../assets/svg/export.svg";
import { ReactComponent as PurchaseSend } from "../../assets/svg/purchaseSend.svg";
import { ReactComponent as RejectSvg } from "../../assets/svg/reject.svg";
import { ReactComponent as SaveSvg } from "../../assets/svg/save.svg";
import DatePicker from "../../components/DatePicker";
import Form from "../../components/Form/Form";
import { Suggest } from "../../components/Form/Suggest";
import { DictText, Text } from "../../components/Form/Text";
import { UploadWithFilename } from "../../components/Form/Upload";
import HtmlText from "../../components/HtmlText";
import PageTitle from "../../components/Layout/PageTitle";
import { UploadOutlined } from '@ant-design/icons';
import { Anchor, Button, Input, Table } from 'antd';
import { Link, useSearchParams } from 'react-router-dom';
import { useTaskDetailDrawer } from "../taskList/components/TaskDetail"; // '@/pages/taskList/components/TaskDetail'
import PriceDrawer, { CodesDrawer } from "./OrderDrawer"; //'@/pages/Supply/Orders/components/Drawer'
import styles from "./index.module.css";
import { useDetail } from "./state";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SUBMIT_BTN_TEXT = {
  wait_submit: '提交',
  wait_audit: '审核'
};
var SUBMIT_BTN_TITLE = {
  wait_submit: '提交',
  wait_audit: '审核通过'
};
var SUBMIT_BTN_PATH = {
  wait_submit: 'submit',
  wait_audit: 'audit'
};
var Detail = function Detail() {
  var _useDetail = useDetail(),
    _useDetail$data = _useDetail.data,
    ref = _useDetail$data.ref,
    allowShowPrice = _useDetail$data.allowShowPrice,
    data = _useDetail$data.data,
    _summary = _useDetail$data.summary,
    searchText = _useDetail$data.searchText,
    detailCol = _useDetail$data.detailCol,
    activeRecord = _useDetail$data.activeRecord,
    priceVisible = _useDetail$data.priceVisible,
    codesVisible = _useDetail$data.codesVisible,
    renderDetails = _useDetail$data.renderDetails,
    _useDetail$action = _useDetail.action,
    onSave = _useDetail$action.onSave,
    onSubmit = _useDetail$action.onSubmit,
    onExport = _useDetail$action.onExport,
    onReject = _useDetail$action.onReject,
    onRebut = _useDetail$action.onRebut,
    onSearchDetail = _useDetail$action.onSearchDetail,
    setSearchText = _useDetail$action.setSearchText,
    onClosePrice = _useDetail$action.onClosePrice,
    onCloseCodes = _useDetail$action.onCloseCodes;
  var openTaskDetailDrawer = useTaskDetailDrawer();
  var listCol = [{
    title: '任务编码',
    dataIndex: 'flowOrderCode',
    render: function render(v) {
      return /*#__PURE__*/_jsx(Link, {
        to: "/Task?flowOrderId=".concat(v),
        onClick: function onClick(e) {
          e.preventDefault();
          openTaskDetailDrawer({
            flowOrderId: v
          }).catch(function () {});
        },
        target: "_blank",
        children: v
      });
    }
  }, {
    title: '任务名称',
    dataIndex: 'flowName'
  }, {
    title: '处理时间',
    dataIndex: 'finishTime'
  }, {
    title: '当前节点',
    dataIndex: 'currentNodeName'
  }, {
    title: '处理人',
    dataIndex: 'currentHandler',
    render: function render() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return value.map(function (e) {
        return "".concat(e.name, "\uFF08").concat(e.code, "\uFF09");
      }).join('、');
    }
  }, {
    title: '状态',
    dataIndex: 'flowStatus',
    render: function render(v) {
      return /*#__PURE__*/_jsx(DictText, {
        dictType: "scm_flow_state",
        value: v
      });
    }
  }, {
    title: '备注',
    dataIndex: 'reason'
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsxs(PageTitle, {
      className: styles.title,
      children: ["\u91C7\u8D2D\u8BA2\u5355\u8BE6\u60C5 ", /*#__PURE__*/_jsx("div", {
        className: styles.line
      }), data.shopName]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.layout,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.left,
        id: "scrollContainer",
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.subTitle,
          id: "\u57FA\u7840\u4FE1\u606F",
          children: "\u57FA\u7840\u4FE1\u606F"
        }), /*#__PURE__*/_jsx(Form, {
          ref: ref,
          mode: "edit",
          labelCol: {
            className: styles.label
          },
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.baseForm,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.formContainer,
              children: [/*#__PURE__*/_jsxs(Form.Field, {
                name: "orderCode",
                label: "\u8BA2\u5355\u53F7",
                children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "purchaseDate",
                label: "\u8BA2\u8D27\u65E5\u671F",
                children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "arrivalDate",
                label: "\u671F\u671B\u5230\u8D27\u65E5\u671F",
                required: data.canEditArrivalDate,
                labelCol: {
                  className: data.canEditArrivalDate ? styles.editBlack : styles.label
                },
                rules: [data.canEditArrivalDate ? {
                  required: true,
                  message: '请选择期望到货日期'
                } : {}],
                children: [data.canEditArrivalDate ? /*#__PURE__*/_jsx(DatePicker
                // showTime
                , {
                  placeholder: "\u8BF7\u9009\u62E9\u671F\u671B\u5230\u8D27\u65E5\u671F"
                  // format='YYYY-MM-DD HH:mm:ss'
                  ,
                  style: {
                    width: '90%'
                  }
                }) : /*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "orderStatus",
                label: "\u8BA2\u5355\u72B6\u6001",
                children: [/*#__PURE__*/_jsx(DictText, {
                  dictType: "scm_purchase_order_status"
                }), /*#__PURE__*/_jsx(DictText, {
                  dictType: "scm_purchase_order_status"
                })]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "dispatchMethod",
                label: "\u914D\u9001\u65B9\u5F0F",
                children: [/*#__PURE__*/_jsx(DictText, {
                  dictType: "scm_delivery_type"
                }), /*#__PURE__*/_jsx(DictText, {
                  dictType: "scm_delivery_type"
                })]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "dispatchStatus",
                label: "\u914D\u9001\u72B6\u6001",
                children: [/*#__PURE__*/_jsx(DictText, {
                  dictType: "scm_purchase_order_dispatch_status"
                }), /*#__PURE__*/_jsx(DictText, {
                  dictType: "scm_purchase_order_dispatch_status"
                })]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "businessType",
                label: "\u5355\u636E\u7C7B\u578B",
                children: [/*#__PURE__*/_jsx(DictText, {
                  dictType: "scm_request_order_business_type"
                }), /*#__PURE__*/_jsx(DictText, {
                  dictType: "scm_request_order_business_type"
                })]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "supplierName",
                label: "\u4F9B\u5E94\u5546",
                children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "virtualWhName",
                label: "\u4ED3\u5E93",
                children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "logisticsServiceName",
                label: "\u4E09\u65B9\u7269\u6D41\u670D\u52A1\u5546",
                children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "relOrderCode",
                label: "\u5173\u8054\u5355\u53F7",
                style: {
                  flexBasis: '66%'
                },
                children: [/*#__PURE__*/_jsx(Text, {
                  prefix: "\u7531\u3010",
                  addonAfter: "\u3011\u91C7\u8D2D\u7533\u8BF7\u5355\u751F\u6210"
                }), /*#__PURE__*/_jsx(Text, {
                  prefix: "\u7531\u3010",
                  addonAfter: "\u3011\u91C7\u8D2D\u7533\u8BF7\u5355\u751F\u6210"
                })]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "shopName",
                label: "\u95E8\u5E97",
                children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: ['shopContact', 'contactAddress'],
                label: "\u5730\u5740",
                style: {
                  flexBasis: '66%'
                },
                children: [data.canEditContract ? /*#__PURE__*/_jsx(Input, {
                  placeholder: "\u8BF7\u8F93\u5165\u5730\u5740"
                }) : /*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: ['shopContact', 'contactName'],
                label: "\u8054\u7CFB\u4EBA",
                children: [data.canEditContract ? /*#__PURE__*/_jsx(Input, {
                  placeholder: "\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA"
                }) : /*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: ['shopContact', 'contactPhone'],
                label: "\u624B\u673A\u53F7",
                style: {
                  flexBasis: '60%'
                },
                children: [data.canEditContract ? /*#__PURE__*/_jsx(Input, {
                  placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7"
                }) : /*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
              }), /*#__PURE__*/_jsxs(Form.Field, {
                name: "remark",
                label: "\u5907\u6CE8",
                style: {
                  flexBasis: '70%'
                },
                children: [/*#__PURE__*/_jsx(HtmlText, {}), /*#__PURE__*/_jsx(HtmlText, {})]
              }), data.installSupplierCode && !data.canEditInstallCompany ? /*#__PURE__*/_jsxs(Form.Field, {
                name: "installSupplier",
                label: "\u5B89\u88C5\u516C\u53F8",
                children: [/*#__PURE__*/_jsx(Text, {
                  render: function render() {
                    var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    return v.label;
                  }
                }), /*#__PURE__*/_jsx(Text, {
                  render: function render() {
                    var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    return v.label;
                  }
                })]
              }) : null, data.installContact && !data.canEditInstall ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs(Form.Field, {
                  name: ['installContact', 'contactName'],
                  label: "\u5B89\u88C5\u4EBA\u5458",
                  children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['installContact', 'contactPhone'],
                  label: "\u5B89\u88C5\u4EBA\u5458\u624B\u673A\u53F7",
                  children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['installContact', 'contactAddress'],
                  label: "\u5B89\u88C5\u4EBA\u5458\u5730\u5740",
                  style: {
                    flexBasis: '70%'
                  },
                  children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
                })]
              }) : null, data.dispatchStatus === 'dispatched' ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs(Form.Field, {
                  name: ['orderLogistics', 'logisticsName'],
                  label: "\u7269\u6D41\u670D\u52A1\u5546",
                  children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['orderLogistics', 'logisticsOrderCode'],
                  label: "\u7269\u6D41\u5355\u53F7",
                  children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['orderLogistics', 'logisticsTime'],
                  label: "\u53D1\u8D27\u65E5\u671F",
                  children: [/*#__PURE__*/_jsx(Text, {}), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['orderLogistics', 'remark'],
                  label: "\u53D1\u8D27\u63CF\u8FF0",
                  style: {
                    flexBasis: '70%'
                  },
                  children: [/*#__PURE__*/_jsx(HtmlText, {}), /*#__PURE__*/_jsx(HtmlText, {})]
                })]
              }) : null]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.formContainer,
              style: {
                marginTop: 10
              },
              children: [/*#__PURE__*/_jsxs(Form.Field, {
                name: "attachment",
                label: "\u9644\u4EF6",
                style: {
                  flexBasis: '35%'
                },
                children: [data.canEditAttachment ? /*#__PURE__*/_jsx(UploadWithFilename, {
                  children: /*#__PURE__*/_jsxs(Button, {
                    size: "middle",
                    style: {
                      color: '#000000E0'
                    },
                    children: [/*#__PURE__*/_jsx(UploadOutlined, {
                      style: {
                        color: '#00000040'
                      }
                    }), "\u70B9\u51FB\u4E0A\u4F20"]
                  })
                }) : /*#__PURE__*/_jsx(UploadWithFilename, {
                  disabled: true
                }), /*#__PURE__*/_jsx(UploadWithFilename, {
                  disabled: true
                })]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  flexBasis: '50%'
                }
              }), data.canEditInstallCompany ? /*#__PURE__*/_jsxs(Form.Field, {
                name: "installSupplier",
                label: "\u5B89\u88C5\u516C\u53F8",
                required: true,
                rules: [{
                  required: true,
                  message: '请选择安装公司'
                }],
                labelCol: {
                  className: styles.editBlack
                },
                children: [/*#__PURE__*/_jsx(Suggest, {
                  url: "/baseinfo/supplier/list",
                  placeholder: "\u8BF7\u9009\u62E9\u5B89\u88C5\u516C\u53F8",
                  style: {
                    width: '90%'
                  },
                  labelInValue: true,
                  requestFilter: function requestFilter(_ref) {
                    var keyword = _ref.keyword;
                    return {
                      page: {
                        index: 1,
                        size: 10,
                        sorts: []
                      },
                      supplierNameLike: keyword
                    };
                  },
                  responseFilter: function responseFilter(data) {
                    return data.map(function (e) {
                      return {
                        label: e.supplierName,
                        value: e.supplierCode
                      };
                    });
                  }
                }), /*#__PURE__*/_jsx(Text, {
                  render: function render(v) {
                    return v.label;
                  }
                })]
              }) : null, data.canEditInstall ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs(Form.Field, {
                  name: ['installContact', 'contactName'],
                  label: "\u5B89\u88C5\u4EBA\u5458",
                  required: true,
                  rules: [{
                    required: true,
                    message: '请输入安装人员'
                  }],
                  labelCol: {
                    className: styles.editBlack
                  },
                  children: [/*#__PURE__*/_jsx(Input, {
                    placeholder: "\u8BF7\u8F93\u5165\u5B89\u88C5\u4EBA\u5458",
                    style: {
                      width: '90%'
                    }
                  }), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['installContact', 'contactPhone'],
                  label: "\u5B89\u88C5\u4EBA\u5458\u624B\u673A\u53F7",
                  required: true,
                  rules: [{
                    required: true,
                    message: '请输入安装人员手机号'
                  }],
                  labelCol: {
                    className: styles.editBlack
                  },
                  children: [/*#__PURE__*/_jsx(Input, {
                    placeholder: "\u8BF7\u8F93\u5165\u5B89\u88C5\u4EBA\u5458\u624B\u673A\u53F7",
                    style: {
                      width: '90%'
                    }
                  }), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['installContact', 'contactAddress'],
                  label: "\u5B89\u88C5\u4EBA\u5458\u5730\u5740",
                  required: true,
                  rules: [{
                    required: true,
                    message: '请输入安装人员地址'
                  }],
                  style: {
                    flexBasis: '70%'
                  },
                  labelCol: {
                    className: styles.editBlack
                  },
                  children: [/*#__PURE__*/_jsx(Input, {
                    placeholder: "\u8BF7\u8F93\u5165\u5B89\u88C5\u4EBA\u5458\u5730\u5740",
                    style: {
                      width: '90%'
                    }
                  }), /*#__PURE__*/_jsx(Text, {})]
                })]
              }) : null, data.canEditLogistic ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs(Form.Field, {
                  name: ['orderLogistics', 'logisticsName'],
                  label: "\u7269\u6D41\u670D\u52A1\u5546",
                  required: true,
                  rules: [{
                    required: true
                  }],
                  labelCol: {
                    className: styles.editBlack
                  },
                  children: [/*#__PURE__*/_jsx(Input, {
                    placeholder: "\u8BF7\u8F93\u5165\u7269\u6D41\u670D\u52A1\u5546",
                    style: {
                      width: '90%'
                    }
                  }), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['orderLogistics', 'logisticsOrderCode'],
                  label: "\u7269\u6D41\u5355\u53F7",
                  required: true,
                  rules: [{
                    required: true,
                    message: '请输入物流单号'
                  }],
                  labelCol: {
                    className: styles.editBlack
                  },
                  children: [/*#__PURE__*/_jsx(Input, {
                    placeholder: "\u8BF7\u8F93\u5165\u7269\u6D41\u5355\u53F7",
                    style: {
                      width: '90%'
                    }
                  }), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['orderLogistics', 'logisticsTime'],
                  label: "\u53D1\u8D27\u65E5\u671F",
                  required: true,
                  rules: [{
                    required: true,
                    message: '请选择发货日期'
                  }],
                  labelCol: {
                    className: styles.editBlack
                  },
                  children: [/*#__PURE__*/_jsx(DatePicker, {
                    showTime: true,
                    placeholder: "\u8BF7\u9009\u62E9\u53D1\u8D27\u65E5\u671F",
                    format: "YYYY-MM-DD HH:mm:ss",
                    style: {
                      width: '90%'
                    }
                  }), /*#__PURE__*/_jsx(Text, {})]
                }), /*#__PURE__*/_jsxs(Form.Field, {
                  name: ['orderLogistics', 'remark'],
                  label: "\u53D1\u8D27\u63CF\u8FF0",
                  style: {
                    flexBasis: '70%'
                  },
                  labelCol: {
                    className: styles.editBlack
                  },
                  children: [/*#__PURE__*/_jsx(Input, {
                    placeholder: "\u8BF7\u8F93\u5165\u53D1\u8D27\u63CF\u8FF0",
                    style: {
                      width: '90%'
                    }
                  }), /*#__PURE__*/_jsx(Text, {})]
                })]
              }) : null]
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.subTitle2,
          id: "\u5355\u636E\u660E\u7EC6",
          children: "\u5355\u636E\u660E\u7EC6"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.searchContainer,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.searchLabel,
            children: "\u5546\u54C1\u7F16\u7801/\u540D\u79F0\uFF1A"
          }), /*#__PURE__*/_jsx(Input, {
            className: styles.searchInput,
            placeholder: "\u8BF7\u8F93\u5165\u5546\u54C1\u7F16\u7801/\u540D\u79F0",
            value: searchText,
            onChange: function onChange(e) {
              return setSearchText(e.target.value);
            }
          }), /*#__PURE__*/_jsx(Button, {
            className: styles.searchBtn,
            onClick: onSearchDetail,
            children: "\u67E5\u8BE2"
          })]
        }), /*#__PURE__*/_jsx(Table, {
          rowKey: function rowKey(record, index) {
            return "".concat(record.item, "-").concat(index);
          },
          scroll: {
            x: 'max-content'
          },
          columns: detailCol,
          dataSource: renderDetails,
          size: "small",
          summary: function summary() {
            return /*#__PURE__*/_jsx(Table.Summary, {
              fixed: true,
              children: /*#__PURE__*/_jsxs(Table.Summary.Row, {
                className: styles.summaryRow,
                children: [/*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 0,
                  className: styles.summaryRow,
                  children: "\u5408\u8BA1"
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 1,
                  className: styles.summaryRow
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 2,
                  className: styles.summaryRow
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 3,
                  className: styles.summaryRow
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 4
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 5
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 6,
                  children: allowShowPrice ? _summary.qty : '-'
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 7,
                  children: allowShowPrice ? _summary.shipmentQty : '-'
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 8
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 9
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 10,
                  children: allowShowPrice ? _summary.amount : '-'
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 11,
                  children: allowShowPrice ? _summary.shipmentAmount : '-'
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 12
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 13,
                  children: allowShowPrice ? _summary.taxAmount : '-'
                }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                  index: 14,
                  children: allowShowPrice ? _summary.shipmentTaxAmount : '-'
                }), data.showSalesColumn ? /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 15
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 16
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 17,
                    children: allowShowPrice ? _summary.salesAmount : '-'
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 18,
                    children: allowShowPrice ? _summary.outputTaxAmount : '-'
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 19
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 20
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 21
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 22
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 23
                  })]
                }) : /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 15
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 16
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 17
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 18
                  }), /*#__PURE__*/_jsx(Table.Summary.Cell, {
                    index: 19
                  })]
                })]
              })
            });
          }
        }), /*#__PURE__*/_jsx("div", {
          className: styles.subTitle2,
          id: "\u5173\u8054\u4EFB\u52A1",
          children: "\u5173\u8054\u4EFB\u52A1"
        }), /*#__PURE__*/_jsx(Table, {
          pagination: false,
          rowKey: function rowKey(record, index) {
            return "".concat(record.item, "-").concat(index);
          },
          scroll: {
            x: 'max-content'
          },
          columns: listCol,
          dataSource: data.orderFlowList
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.right,
        children: /*#__PURE__*/_jsx(Anchor, {
          replace: true,
          offsetTop: 16,
          getCurrentAnchor: function getCurrentAnchor(s) {
            return s;
          },
          getContainer: function getContainer() {
            return document.getElementById('scrollContainer');
          },
          items: [{
            key: '基础信息',
            href: '#基础信息',
            title: '基础信息'
          }, {
            key: '单据明细',
            href: '#单据明细',
            title: '单据明细'
          }, {
            key: '关联任务',
            href: '#关联任务',
            title: '关联任务'
          }]
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.btnContainer,
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onExport,
        icon: /*#__PURE__*/_jsx(ExportSvg, {}),
        children: "\u5BFC\u51FA"
      }), data.showSave ? /*#__PURE__*/_jsx(Button, {
        onClick: onSave,
        icon: /*#__PURE__*/_jsx(SaveSvg, {}),
        children: "\u4FDD\u5B58"
      }) : null, data.canReject ? /*#__PURE__*/_jsx(Button, {
        onClick: onReject,
        icon: /*#__PURE__*/_jsx(RejectSvg, {}),
        type: "primary",
        children: "\u62D2\u7EDD"
      }) : null, data.canRebut ? /*#__PURE__*/_jsx(Button, {
        onClick: onRebut,
        icon: /*#__PURE__*/_jsx(RejectSvg, {}),
        type: "primary",
        children: "\u9A73\u56DE"
      }) : null, data.showOperate ? /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          return onSubmit(SUBMIT_BTN_TITLE[data.orderStatus], SUBMIT_BTN_PATH[data.orderStatus]);
        },
        icon: data.canEditShipmentQty ? /*#__PURE__*/_jsx(PurchaseSend, {}) : /*#__PURE__*/_jsx(AduitSvg, {}),
        type: "primary",
        children: data.canEditShipmentQty ? '发货' : SUBMIT_BTN_TEXT[data.orderStatus]
      }) : null]
    }), /*#__PURE__*/_jsx(PriceDrawer, {
      visible: priceVisible,
      data: activeRecord,
      onClose: onClosePrice
    }), /*#__PURE__*/_jsx(CodesDrawer, {
      visible: codesVisible,
      data: activeRecord,
      onClose: onCloseCodes,
      numberKey: "shipmentQty"
    })]
  });
};
export default (function () {
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var orderCode = searchParams.get('orderCode');
  return /*#__PURE__*/_jsx(Detail, {}, orderCode);
});